import { Injectable } from '@angular/core';
import { DateRangeInterval } from '@app/core/components/date-range/date-range.component';
import { GridRow } from '@app/core/components/grid/grid.types';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';
import { CustomerAccountInfo } from '@app/services/typeahead.service';

@Injectable({
    providedIn: 'root',
})
export class AcSuppTransService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 2791
     * @datataskName sp_ws_p2_w_acsupptranses_get
     * @returns promise containing page get for ac-supp-transes.
     */
    public async getAcSuppTranses(params: GetAcSuppTransesParams): Promise<AcSuppTransesGet> {
        const page = (await this.datatask.Post(2791, params))[0] as AcSuppTransesResponse;

        return { ...page, suppliers: JSON.parse(page.suppliers || '[]') as CustomerAccountInfo[] };
    }

    /**
     * @datatask 2824
     * @datataskName sp_ws_p2_acsupptranses_remove_matching
     * @returns promise containing validation for the removing of matching.
     */
    public async removeAcSuppTransesMatching(params: AcSuppTransesGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(2824, params))[0];
    }

    /**
     * @datatask 2825
     * @datataskName sp_ws_p2_acsupptranses_match_selected
     * @returns promise containing validation for the matching.
     */
    public async matchSelectedAcSuppTranses(params: MatchSelectedAcSuppTransesParams): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(2825, params))[0];
    }

    /**
     * @datatask 2826
     * @datataskName sp_ws_p2_acsupptranses_automatch
     * @returns promise containing validation for the auto match.
     */
    public async autoMatchAcSuppTranses(params: AcSuppTransesGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(2826, params))[0];
    }

    /**
     * @datatask 2828
     * @datataskName sp_ws_p2_w_acsupptrans_get
     * @param params the keyno
     * @returns promise containing the acsupptrans.
     */
    public async getAcSuppTrans(params: GetAcSuppTransParams): Promise<AcSuppTransGet> {
        return (await this.datatask.Post(2828, params))[0];
    }

    /**
     * @datatask 2830
     * @datataskName sp_ws_p2_w_acsupptrans_remove_matching_selected
     * @param params the acsupptrans and the records to remove match on.
     * @returns promise containing validation.
     */
    public async removeAcSuppTransMatching(params: RemoveAcSuppTransMatchingParams): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(2830, params))[0];
    }
}

export interface GetAcSuppTransParams {
    acsupptrans_keyno: string;
}

export interface GetAcSuppTransesParams {
    acc_supp_no: string;
}

export interface AcSuppTransGet {
    acsupptrans_keyno: string;
    heading_matching: string;
}

export interface AcSuppTransesGet {
    page_heading: string;
    businessco_no: string;
    openpost: '0' | '1';
    show_account_saldo: '0' | '1';
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
    date_fomtom: string;
    date_tom_open_post: string;
    date_today: string;
    date_not_today_warning: string;
    acc_supp_no: string;
    suppliers: CustomerAccountInfo[];
}

export interface AcSuppTransesGridRow extends GridRow {
    acsupptrans_keyno: number;
    amount_locval_balance: number;
    is_selected: boolean;
    is_selected_amount_locval_balance: number;
}

export interface RemoveAcSuppTransMatchingParams extends AcSuppTransGet {
    records: { acsupptransmatch_keyno: string | number }[];
}

export interface MatchSelectedAcSuppTransesParams extends AcSuppTransesGet {
    records: { acsupptrans_keyno: number }[];
}

interface AcSuppTransesResponse extends Omit<AcSuppTransesGet, 'suppliers'> {
    suppliers: string;
}
